export default "__VITE_ASSET__BnsVwuGG__"